export default __webpack_public_path__ + "static/media/case-study5.6d91a29b.webp";